// extracted by mini-css-extract-plugin
export default {"InlineInputs":"InlineInputs__InlineInputs___xpzX0","inputsContainer":"InlineInputs__inputsContainer___JRlHc"};